import useSWR from "swr";
import { customFetcher, notify } from "../../../../utils";
import { JobTitle } from "../../../../globals/interfaces";
import VirtualTable from "../../../../components/custom/VirtualTable";
import styled from "styled-components";
import ActionIcon from "../../../../components/custom/ActionIcon";
import { useState } from "react";
import useModal from "../../../../customHooks/useModal";
import ModalJobTitles from "./ModalJobTitles";
import { useAppContext } from "../../../../context";
import apiClient from "../../../../apiClient";
import useJobTitles from "./useJobTitles";
import ModalDelete from "./ModalDelete";

export default function JobTitles () {

    const { user } = useAppContext();
    const {
        data,
        mutate
    } = useJobTitles();

    const [selectedId, setSelectedId] = useState<number>();
    const { modal, setModal } = useModal();
    const { modal: modalDelete, setModal: setModalDelete } = useModal();
    const updateItem = data.find(item => item.id === selectedId);

    const launchCreateUpdateJobTitle = (id?: number) => {
        if (id) {
            setSelectedId(id);
        } else {
            setSelectedId(undefined);
        }
        setModal(true);
    }

    const handleCreateUpdateJobTitle = async (data: JobTitle) => {
        try {
            delete data.id;

            let method = 'post', url = `/job-title`;

            if (updateItem) {
                method = 'put';
                url += `/${selectedId}`;
            }

            const res = await apiClient[method](url, data);

            mutate();
            setModal(false);
            notify(updateItem ? 'Updated' : 'Create');
        } catch (err) {
            alert(err);
        }
    }

    const launchDeleteJob = () => {
        setModalDelete(true);
    }

    const deleteJob = async () => {
        try {
            await apiClient.delete(`/job-title/${updateItem.id}`);
            setModalDelete(false);
            setModal(false);
            notify('Deleted');
            mutate();
        } catch (err) {
            alert(err);
        }
    }

    return (
        <div>
            <Header>
                <h4>Job Titles</h4>
                <ActionIcon 
                    type={'add'}
                    onClick={() => launchCreateUpdateJobTitle()}
                />
            </Header>
            <VirtualTable<JobTitle> 
                data={data}   
                mapping={[{
                    name: 'Job ID',
                    value: 'jobId'
                }, {
                    name: 'Department',
                    value: 'department'
                }, {
                    name: 'Job Title',
                    value: 'title'
                }, {
                    name: 'Created by',
                    value: 'createdBy',
                    email: true
                }, {
                    name: 'Created at',
                    value: 'createdAt',
                    utc: true,
                    datetime: true
                }, {
                    name: 'Modified by',
                    value: 'modifiedBy',
                    email: true
                }, {
                    name: 'Modified at',
                    value: 'modifiedAt',
                    utc: true,
                    datetime: true
                }]} 
                handleClick={item => launchCreateUpdateJobTitle(item.id)}
            />
            <ModalJobTitles 
                modal={modal}
                setModal={setModal}
                updateItem={updateItem}
                user={user}
                handleCreateUpdateJobTitle={handleCreateUpdateJobTitle}
                launchDeleteJob={launchDeleteJob}
            />
            <ModalDelete 
                modal={modalDelete}
                setModal={setModalDelete}
                jobTitle={updateItem}
                deleteJob={deleteJob}
            />
        </div>
    );
}

const Header = styled.div`
    display: flex;
    justify-content: space-between;
`;